import Favourability from "./favourability";

export default Favourability;